<script>
  import LinkMolecule from '~/Components/Molecules/Link'
  import {viewCard} from '~/Library/helpers'

  export let card = {}
  export let index = 0 
</script>

<div class="card" on:click={viewCard(index)}>

  {#if card.image}

    <img src={card.image.publicUrlTransformed} alt="" class="card__icon">

  {/if}

  <div class="card__content">

    <h4 class="card__headline">{card.title}</h4>

    <p class="card__text">{card.short_description}</p>

    {#if card.availability}

      <small class="card__availability">{card.availability}</small>

    {/if}

    <div class="card__actions">

      <LinkMolecule cta="View mentor" className="accent" callback={viewCard(index)} />
      
    </div>

  </div>

</div>

<style lang="scss">
  .card {
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    cursor: pointer;

    overflow: hidden;

    box-shadow: 0px 30px 50px rgba(95, 105, 131, 0.08);
    background: white;
    border-radius: 1rem;

    min-width: 30%;
    max-width: 30%;
    height: 34rem;
    z-index: 10;

    margin-right: 1rem;
    margin-bottom: 1rem;
    
    &__content {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      padding: 1rem 2rem;
    }
    &__availability {
      flex-grow: 1;
      margin: 0.75rem 0;
    }
    &__headline {
      font-weight: bold;
    }
    &__icon {
      width: 100%;
      object-fit: cover;
      height: 13rem;
      -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
      filter: grayscale(100%);
    }
    &__text {
      margin: 0.5rem 0;
      font-size: 0.875rem;
    }
    &__actions {
      display: flex;
      align-items: center;
      justify-content: space-between;
      &-cal {
        height: 2.25rem;
        width: 2.25rem;
        padding-bottom: 1rem;
        cursor: pointer;
      }
    }

    @media only screen and (max-width: 576px) {
      max-width: unset;
      margin: unset;
      margin-bottom: 2rem;
      height: fit-content;
    }
  }
</style>